import { useState, useEffect, useCallback } from 'react';

const API = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

const TYPE_LABEL = { process: '⚙️ Jarayon', file: '📁 Fayl' };
const TYPE_COLOR = { process: '#ef4444', file: '#f97316' };

export default function AntiCheat() {
  const [logs, setLogs]       = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter]   = useState('all');

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${API}/owner/anticheat-logs`, { headers: headers() });
      if (r.ok) setLogs(await r.json());
    } catch {}
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);

  const filtered = filter === 'all' ? logs : logs.filter(l => l.type === filter);

  return (
    <div style={{ padding: '28px', maxWidth: 1000, margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 24, fontWeight: 800 }}>🛡️ Anti-Cheat Loglar</h1>
          <p style={{ margin: '4px 0 0', color: '#6b7280', fontSize: 14 }}>
            Kompyuterlarda aniqlangan shubhali fayl va dasturlar
          </p>
        </div>
        <button onClick={load} style={{
          padding: '10px 20px', borderRadius: 10, border: 'none',
          background: '#1f2937', color: '#9ca3af', cursor: 'pointer', fontSize: 14,
        }}>
          🔄 Yangilash
        </button>
      </div>

      {/* Summary */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 12, marginBottom: 20 }}>
        {[
          { label: 'Jami hodisa', value: logs.length, color: '#6b7280' },
          { label: 'Jarayon (process)', value: logs.filter(l => l.type === 'process').length, color: '#ef4444' },
          { label: 'Fayl (download)', value: logs.filter(l => l.type === 'file').length, color: '#f97316' },
        ].map(s => (
          <div key={s.label} style={{ background: '#111827', border: '1px solid #1f2937', borderRadius: 12, padding: '16px 20px' }}>
            <div style={{ fontSize: 28, fontWeight: 800, color: s.color }}>{s.value}</div>
            <div style={{ fontSize: 12, color: '#6b7280', marginTop: 4 }}>{s.label}</div>
          </div>
        ))}
      </div>

      {/* Filter */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        {['all', 'process', 'file'].map(f => (
          <button key={f} onClick={() => setFilter(f)} style={{
            padding: '7px 16px', borderRadius: 20, border: '1px solid',
            borderColor: filter === f ? '#ef4444' : '#374151',
            background: filter === f ? 'rgba(239,68,68,0.1)' : 'transparent',
            color: filter === f ? '#ef4444' : '#9ca3af',
            cursor: 'pointer', fontSize: 13,
          }}>
            {f === 'all' ? 'Barchasi' : f === 'process' ? '⚙️ Jarayonlar' : '📁 Fayllar'}
          </button>
        ))}
      </div>

      {/* Table */}
      {loading ? (
        <div style={{ textAlign: 'center', padding: 60, color: '#6b7280' }}>Yuklanmoqda...</div>
      ) : filtered.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 60, background: '#111827', borderRadius: 16, color: '#6b7280' }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>✅</div>
          <div style={{ fontSize: 16, fontWeight: 700 }}>Hech narsa aniqlanmagan</div>
          <div style={{ fontSize: 13, marginTop: 6 }}>Yoki hali PC ulanmagan</div>
        </div>
      ) : (
        <div style={{ background: '#111827', borderRadius: 16, overflow: 'hidden', border: '1px solid #1f2937' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#0d1117', borderBottom: '1px solid #1f2937' }}>
                {['Sana', 'Lab / PC', 'Turi', 'Nom (chit nomi)'].map(h => (
                  <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontSize: 11,
                    fontWeight: 600, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map((log, i) => (
                <tr key={log.id} style={{ borderBottom: i < filtered.length - 1 ? '1px solid #1f2937' : 'none' }}
                  onMouseEnter={e => e.currentTarget.style.background = '#0d1117'}
                  onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                  <td style={{ padding: '12px 16px', fontSize: 13, color: '#9ca3af' }}>
                    {new Date(log.detected_at).toLocaleString('uz-UZ')}
                  </td>
                  <td style={{ padding: '12px 16px', fontSize: 13 }}>
                    <span style={{ fontWeight: 600 }}>{log.lab_name}</span>
                    <span style={{ color: '#6b7280', marginLeft: 8 }}>PC #{log.computer_number}</span>
                  </td>
                  <td style={{ padding: '12px 16px' }}>
                    <span style={{
                      padding: '3px 10px', borderRadius: 99, fontSize: 12, fontWeight: 600,
                      background: `${TYPE_COLOR[log.type] || '#6b7280'}20`,
                      color: TYPE_COLOR[log.type] || '#6b7280',
                    }}>
                      {TYPE_LABEL[log.type] || log.type}
                    </span>
                  </td>
                  <td style={{ padding: '12px 16px', fontFamily: 'monospace', fontSize: 13, color: '#f87171' }}>
                    {log.name}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
